/* ------------------------------------- DEPENDENCIES -------------------------------------- */
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
/* ------------------------------------- MATERIAL UI --------------------------------------- */
import { Button, Card, Container, Grid, Stack } from '@mui/material';

/* ------------------------------------- COMPONENTS ---------------------------------------- */
import Page from '../components/Page';
import SubscriptionHead from '../components/subscription/SubscriptionHead';
import SubscriptionBillingForm from '../components/subscription/SubscriptionBillingForm';
import SubscriptionInfo from '../components/subscription/SubscriptionInfo';
import SubscriptionSummary from '../components/subscription/SubscriptionSummary';
import { useTranslation } from '../common/LocalizationProvider';

export default function Subscription() {
  const stripe = loadStripe(process.env.REACT_APP_STRIPE_KEY);

  const t = useTranslation();

  const navigate = useNavigate();
  return (
    <Page title="Subscription | Click and Take off">
      <Container>
        <SubscriptionHead />

        <Elements stripe={stripe}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={7} lg={7} xl={8}>
              <Card>
                <Stack spacing={3} padding={6}>
                  <Stack spacing={1} direction="row">
                    <Button onClick={() => navigate('/subscription/plans', { replace: true })}>
                      <Icon icon="mdi:arrow-left-thin" width={24} height={24} />
                      {t('sub_Back')}
                    </Button>
                  </Stack>

                  <Stack spacing={4} direction="row">
                    <Grid container spacing={4}>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
                        <SubscriptionBillingForm />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
                        <SubscriptionInfo />
                      </Grid>
                    </Grid>
                  </Stack>
                </Stack>
              </Card>
            </Grid>

            <Grid item xs={12} sm={12} md={5} lg={5} xl={4}>
              <SubscriptionSummary />
            </Grid>
          </Grid>
        </Elements>
      </Container>
    </Page>
  );
}
